import { createMultiStyleConfigHelpers, } from "@chakra-ui/styled-system";
import { keyframes } from "@chakra-ui/system";
import { SkeletonTypes } from "../Skeleton.types";
const keyframe = keyframes `
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
`;
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(["skeletonStyle"]);
function getBorderRadiusMap(width, type) {
    if (type === SkeletonTypes.CIRCLE) {
        return width;
    }
    if (type === SkeletonTypes.ROUNDED_RECTANGLE) {
        return "4px";
    }
    return 0;
}
const baseStyle = definePartsStyle(({ type, width }) => ({
    skeletonStyle: {
        position: "relative",
        backgroundColor: "semantic.surface.skeleton",
        overflow: "hidden",
        borderRadius: getBorderRadiusMap(width, type),
        _after: {
            content: '""',
            animation: `${keyframe} 1.2s infinite`,
            height: "100%",
            left: 0,
            position: "absolute",
            right: 0,
            top: 0,
            transform: "translateX(-100%)",
            zIndex: 1,
            bgGradient: "linear-gradient(90deg, semantic.surface.skeleton, rgba(255, 255, 255, 0.4), semantic.surface.skeleton)",
        },
    },
}));
const SkeletonTheme = defineMultiStyleConfig({
    baseStyle,
});
export default SkeletonTheme;
//# sourceMappingURL=Skeleton.default.js.map